<template>
  <!-- <div class="pa-6 mx-auto" > -->
  <div class="py-6 pl-0 ml-0" >
    <v-row>
      <v-col :cols="!$vuetify.breakpoint.mobile ? 9 : 12">

          <!-- <h1>CRM Connect</h1> -->
          <v-container>
            <v-alert 
              v-if="displayAlert == true" 
              class="px-5 mx-auto"
              width="600" 
              :type="showAlert.type"
              :dismissible="!!showAlert.dismissable"
              dense
            >
              {{showAlert.message}}
            </v-alert>

            <v-card width="400" class="mx-auto">
              <v-card-title class="justify-center pa-2">
                <label class="title">{{ $t('login.login') }}</label>
              </v-card-title>
              <v-card-text class="pb-0">
                <v-form ref="signInForm" v-model="formValidity" @submit.prevent="login">
                  <v-container class="pb-0">
                    <v-text-field 
                      :label="$t('login.accountNumber')"
                      v-model="leAccountNumber"
                      :rules="leAccountNumberRules"
                      prepend-icon="mdi-account-circle"
                      required
                      outlined
                      dense
                    />
                    <v-text-field 
                      :label="$t('login.email')"
                      type="email"
                      v-model="email"
                      :rules="emailRules"
                      prepend-icon="mdi-email"
                      required
                      outlined
                      dense
                    />
                    <v-text-field 
                      :type="showPassword ? 'text' : 'password'"
                      :label="$t('login.password')"
                      v-model="password"
                      :rules="passwordRules"
                      prepend-icon="mdi-lock"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                      @keyup.enter="login"
                      required
                      outlined
                      dense
                    />
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions class="pt-0 justify-center">
                <!-- <v-btn 
                  color="#D32F2F"
                  @click="resetForm"
                  class="ma-5"
                  dark
                >{{ $t('clear') }}</v-btn>
                <v-spacer></v-spacer> -->
                <v-btn 
                  color="#173862"
                  :disabled="!formValidity"
                  @click="login"
                  class="ma-5 white--text"
                >{{ $t('login.login') }}</v-btn>
              </v-card-actions>
            </v-card>
            <p class="mx-auto mt-5">
              {{ $t('login.dontHaveAccount') }} <router-link to="/registration">{{ $t('registration.registration') }} </router-link>
            </p>
            <p class="mx-auto mt-5">
              <router-link to="/forgetPassword">{{ $t('login.forgetPassword') }} </router-link>
            </p>
            <!-- <button @click="hideRecaptchaBadge">Hide recaptcha</button> -->

          </v-container>
        </v-col>
      <v-col cols="12" sm="3" v-if="!$vuetify.breakpoint.mobile">

      </v-col>
    </v-row>

    <v-row v-if="$vuetify.breakpoint.mobile">
      <v-col cols="12" class="py-0 mt-0">
        <LoginTrialCard />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { load } from 'recaptcha-v3'
  import i18n from '../i18n';

  load(process.env.VUE_APP_RECAPTCHA_SITE_KEY,{
    useRecaptchaNet: true,
    explicitRenderParameters:{
      badge: 'bottomleft',
      tabindex: 3
    }
  });

  export default {
    components: {
      LoginTrialCard: () => import('@/components/LoginTrialCard')
    },
    data: () => ({
      showAlert: {},
      displayAlert: false,
      email: '',
      emailRules: [
        value => !!value || i18n.t('validation.email.isRequired'),
        value => value.indexOf('@') !== 0 || i18n.t('validation.email.shouldHaveUsername'),
        value => value.includes('@') || i18n.t('validation.email.shouldIncludeAt'),
        value => value.lastIndexOf('.') - value.indexOf('@') > 1 || i18n.t('validation.email.missingPeriodSymbol'),
        value => value.lastIndexOf('.') <= value.length - 3 || i18n.t('validation.email.invalidExtension')
      ],
      error: null,
      formValidity: false,
      name: 'LoginPage',
      showPassword: false,
      password: '',
      passwordRules: [
        value => !!value || i18n.t('validation.password.isRequired'),
        // value => value.length <= 7 || 'Password length must be 8 characters or more.'
      ],
      leAccountNumber: '',
      leAccountNumberRules: [
        value => !!value || i18n.t('validation.accountNumber.isRequired'),
        // value => value.length == 0 || 'Account Number length must be 1 characters or more.'
      ]
    }),
    created () {
      this.$store.dispatch('users/resetState')
      this.$store.commit('users/SET_SNACK_IS_BLOCKED', false)
    },
    methods: {
      showSnack: function (snack, isError) {
        const setSnackObj = {
          message: snack,
          isError: !!isError
        }
        this.setSnack(setSnackObj)
      },
      ...mapMutations({
        setSnack: 'setSnack'
      }),
      resetForm() {
        this.$refs.signInForm.reset()
      },
      async login () {
        console.log(`[Login] - login - Check user authorization!`)

        // const recaptcha = await load(process.env.VUE_APP_RECAPTCHA_SITE_KEY);
        // const token = await recaptcha.execute('login');
        
        this.$store
        .dispatch('users/login', {
          username: this.email,
          accountId: this.leAccountNumber,
          password: this.password,
          // recaptchaToken: token
          recaptchaToken: 'token'
        })
        .then((status) => {
          console.log(`[Login] - login - Valid user.`)
          if (status) {
            this.$router.push({ name: 'accounts' })
            this.hideRecaptchaBadge();
          } 
        })
        .catch(err => {
          console.error(`[LOGIN] - Invalid user.`)
          console.error(`[LOGIN] - error: `, err)

          // Dispaly alert
          this.displayAlert = true;
          this.showAlert = { 
            type: 'error', 
            message: (err.response.data.value.error.description) ? `${i18n.t('login.loginFailure')} ${err.response.data.value.error.description}` : `${i18n.t('login.loginFailure')} ${i18n.t('login.tryAgain')}`,
            dismissable: true
          };
          
          this.scrollToTop();
          this.hideAlert();
        })
      },
      scrollToTop() {
        window.scrollTo(0,0);
      },
      hideAlert () {
        //Hide alert after 10 secs
        setTimeout(()=>{
          this.displayAlert = false;
          this.showAlert = {};
        },10000);
      },
      hideRecaptchaBadge () {
        if (document.getElementsByClassName('grecaptcha-badge')){
          const node = document.getElementsByClassName('grecaptcha-badge')[0];
          if(node.style) node.style.visibility = 'hidden'; 
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>